export const isAdaptableSharedEntity = (entity) => entity.EntityType === 'adaptableEntity';
export const isCustomSharedEntity = (entity) => entity.EntityType === 'customEntity';
